/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsLeftRight = createReactComponent("outline", "arrows-left-right", "IconArrowsLeftRight", [["path", { "d": "M21 17l-18 0", "key": "svg-0" }], ["path", { "d": "M6 10l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M3 7l18 0", "key": "svg-2" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-3" }]]);

export { IconArrowsLeftRight as default };
//# sourceMappingURL=IconArrowsLeftRight.mjs.map
